//引入react核心库
import React, { lazy, Suspense } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { Provider } from 'react-redux';
import { store } from '@/store';
//引入APP
import App from "@/App";
//引入loading
import Loading from "@/components/Loading";
import { mainRoutes as mainRoutes1, adminRoutes as adminRoutes1 } from "./routes";
import { mainRoutes as mainRoutes2, adminRoutes as adminRoutes2 } from "./newRoutes";
import { getVersion } from "@/utils/auth";

const getCookieValue = (cookieName) => {
  if (document.cookie) {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      if (cookie.indexOf(cookieName + "=") === 0) {
        return cookie.substring(cookieName.length + 1);
      }
    }
    return undefined;
  }
  return undefined;
};
const cookieToken = getCookieValue("dots-token");
if (cookieToken !== undefined) {
  localStorage.setItem("dots-token", cookieToken);
}
const token = localStorage.getItem("dots-token");
const version = getVersion();
export const mainRoutes = version ? mainRoutes1 : mainRoutes2;
export const adminRoutes = version ? adminRoutes1 : adminRoutes2;

export const MyRouter = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/admin" render={(routeProps) => <Provider store={store}><App {...routeProps} /></Provider>} />
        {mainRoutes.map((route) => {
          return <Route key={route.path} {...route}></Route>;
        })}
        <Redirect from="/" to={token == null ? mainRoutes[0].path : adminRoutes[0].path} />
        <Redirect to="/404" />
      </Switch>
    </BrowserRouter>
  );
};

export const MenuRouter = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        {renderRoutes(adminRoutes)}
        {/* 二级路由配置 */}
        <Redirect to={adminRoutes[0].path} from="/admin" />
        <Redirect to="/404" />
      </Switch>
    </Suspense>
  );
};